<template>
  <div class="wrapper">
    <div class="requests">
      Новые заявки: {{ getUnreadCount.unreadRequests }}
    </div>
    <div class="comments">
      Новые комментарии: {{ getUnreadCount.unreadComments }}
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getUnreadCount"])
  }
};
</script>
<style scoped>
.wrapper {
  display: flex;
  gap: 1em;
}
.requests {
  color: #409eff;
  text-align: end;
}
.comments {
  color: #e6a23c;
  text-align: end;
}
</style>
